import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;

let isInitialized = false;

// Initialize Mixpanel as early as possible
export function initMixpanel() {
  if (!MIXPANEL_TOKEN) {
    // eslint-disable-next-line no-console
    console.error('Mixpanel token is missing. Set VITE_MIXPANEL_TOKEN in your environment.');
    return;
  }
  if (!isInitialized) {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: import.meta.env.DEV,
      track_pageview: false, // We'll track manually
      persistence: 'localStorage',
      batch_requests: false,
      disable_cookie: false,
      disable_persistence: false,
      // Enable Replay
      replay: true,
    });
    isInitialized = true;
  }
}

// Identify user and set properties (best practice: call after login/register)
export function identifyUser(userId: string | null | undefined, email?: string, name?: string) {
  if (!isInitialized || !userId) return;
  mixpanel.identify(userId);
  const props: Record<string, string> = {};
  if (email) props.email = email;
  if (name) props.name = name;
  if (Object.keys(props).length > 0) {
    mixpanel.people.set(props);
  }
}

// Reset Mixpanel on logout
export function resetMixpanel() {
  if (!isInitialized) return;
  mixpanel.reset();
}

// Track a page view (call on route change)
export function trackPageView(props: Record<string, any>) {
  if (!isInitialized) return;
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.debug('[Mixpanel] Page View:', props);
  }
  mixpanel.track('$mp_web_page_view', props);
}

export default mixpanel; 